import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import Spacer from '../spacer';
import Colors from '../colors';
const StyledBottom = styled.View`
  height: 265px;
  width: 100%;
  border-radius: 15px;
  background-color: ${Colors.white};
  position: absolute;
  bottom: -20px;
  padding: 8px 24px 44px 24px;
`;
const Widget = styled.View`
  margin-left: auto;
  margin-right: auto;
  width: 40px;
  height: 4px;
  background: ${Colors.lightGray400};
  border-radius: 4px;
  justify-content: center;
`;
export default function BottomSheet(props) {
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(StyledBottom, null, /*#__PURE__*/React.createElement(Widget, null), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    height: true
  }), props.children));
}
BottomSheet.defaultProps = {
  children: ''
};
BottomSheet.propTypes = {
  children: PropTypes.node
};
//# sourceMappingURL=bottom-sheet.js.map